import { useQuery } from "@tanstack/react-query";
import CareerManagersService from "../services/api/careerManagers/CareerManagers.service";
import {
  CAREER_MANAGERS_PAGE_SIZE,
  RefreshReactQuery,
} from "../constants/AppConstants";
import { FilterProps } from "../types/AppTypes";
import FiltersService from "../services/api/filters/filters.service";
import { useNotification } from "./notification.hook";
import { useEffect } from "react";
import { ERROR_LABEL, ERROR_MESSAGE_LABEL } from "../constants/Dictionary";

interface useCareerManagersProps {
  paginationCareerManagers: number;
  filtersCareerManagers: FilterProps[];
  debounceSearchCareerManager: string;
}

export const useCareerManagers = ({
  paginationCareerManagers,
  filtersCareerManagers,
  debounceSearchCareerManager,
}: useCareerManagersProps) => {
  const { notification } = useNotification();
  const { data, isLoading, isFetching, isError } = useQuery({
    queryKey: [
      "get-career-managers",
      filtersCareerManagers,
      paginationCareerManagers,
      debounceSearchCareerManager,
    ],
    queryFn: ({ signal }) =>
      CareerManagersService.list(
        CAREER_MANAGERS_PAGE_SIZE,
        paginationCareerManagers,
        [
          ...filtersCareerManagers,
          ...(debounceSearchCareerManager
            ? [{ key: "search", value: [debounceSearchCareerManager] }]
            : []),
        ],
        signal,
      ),
    staleTime: RefreshReactQuery.MODERATE,
  });

  useEffect(() => {
    if (isError) {
      notification.error(ERROR_LABEL, ERROR_MESSAGE_LABEL);
    }
  }, [isError]);

  return { data, isLoading, isFetching };
};

export const useCareerManagersFilters = () => {
  const { notification } = useNotification();
  const { data, isLoading, isError } = useQuery({
    queryKey: ["get-filters-career-managers"],
    queryFn: FiltersService.listForCareerManagers,
    staleTime: RefreshReactQuery.INFINITY,
  });

  useEffect(() => {
    if (isError) {
      notification.error(ERROR_LABEL, ERROR_MESSAGE_LABEL);
    }
  }, [isError]);

  return { data, isLoading };
};
